import React, {memo, Suspense} from "react"
import {MANIFEST} from "@manifest/header"
import {PopperPlacementType} from "@mui/material"
import {TemplateSettingsModel, useTemplatedComponent} from "@next/templating"
import connect from "./connect"

export type MyAccountLoggedInTooltipProps = {
    open: boolean
    anchorEl: React.Ref<HTMLElement> | undefined
    handleClose: (event: MouseEvent | TouchEvent) => void
    // eslint-disable-next-line react/require-default-props
    placement?: PopperPlacementType | undefined
    tooltipIcon: string
    accessibilityText: string
    url: string
    text: {
        title: string
        buttonText: string
        notText: string
    }
    firstName: string
    signoutUrl: string
    // eslint-disable-next-line react/require-default-props
    enableModArrow?: boolean | undefined
    // eslint-disable-next-line react/require-default-props
    children?: React.ReactNode
    showStaticHeaderBanner: boolean
} & TemplateSettingsModel

export const MyAccountLoggedInTooltip = memo(
    ({mainTemplate, fallbackTemplate, showStaticHeaderBanner, children, ...props}: MyAccountLoggedInTooltipProps) => {
        const ComponentName = useTemplatedComponent({mainTemplate, fallbackTemplate}, MANIFEST)

        const componentProps = {
            showStaticHeaderBanner,
            ...props,
        }

        return (
            <Suspense>
                <ComponentName {...componentProps}>{children}</ComponentName>
            </Suspense>
        )
    },
)
MyAccountLoggedInTooltip.displayName = "MyAccountLoggedInTooltip"

export default connect(MyAccountLoggedInTooltip)
